// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,optimize_code_size
// @generated from protobuf file "qliq_protobuf/chat_widget_message_type.proto" (package "qliq_protobuf", syntax proto3)
// tslint:disable
/**
 * @generated from protobuf enum qliq_protobuf.ChatWidgetMessageType
 */
export enum ChatWidgetMessageType {
    /**
     * @generated from protobuf enum value: CHAT_WIDGET_MESSAGE_TYPE_UNDEFINED = 0;
     */
    CHAT_WIDGET_MESSAGE_TYPE_UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: WELCOME = 1;
     */
    WELCOME = 1,
    /**
     * @generated from protobuf enum value: ANONYMOUS = 2;
     */
    ANONYMOUS = 2,
    /**
     * @generated from protobuf enum value: KNOWN = 3;
     */
    KNOWN = 3,
    /**
     * @generated from protobuf enum value: TEASER = 4;
     */
    TEASER = 4,
    /**
     * @generated from protobuf enum value: TAC = 5;
     */
    TAC = 5,
    /**
     * @generated from protobuf enum value: START = 6;
     */
    START = 6,
    /**
     * @generated from protobuf enum value: COMPLIANCE = 7;
     */
    COMPLIANCE = 7,
    /**
     * @generated from protobuf enum value: ABOUT = 8;
     */
    ABOUT = 8,
    /**
     * @generated from protobuf enum value: CUSTOM_WELCOME = 9;
     */
    CUSTOM_WELCOME = 9,
    /**
     * @generated from protobuf enum value: AUTH_FAILED = 10;
     */
    AUTH_FAILED = 10
}
